/**
 * @file Image atom — sized image primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/Image
 */
export { Image } from "@/components/ui/image";
